<template>
  <BikeSetup
    v-if="bikeFinalSetup"
    :bike-category="
      getBikeCategory(bikeData?.MAIN_BIKETYPE_NAME, bikeData?.SUB_BIKETYPE_NAME)
    "
    :crank-arm-length="finalMeasurement.crankset.active"
    :crank-arm-length-diff="
      bikeData?.CRANK_LENGTH
        ? bikeData?.CRANK_LENGTH - bikeFinalSetup.setupResult?.CrankLength
        : 0
    "
    :pedal-height="finalMeasurement.pedal.active.PEDAL_HEIGHT"
    :pedal-height-diff="
      bikeData?.PEDAL_HEIGHT
        ? bikeData.PEDAL_HEIGHT - bikeFinalSetup.setupResult?.PedalHeight
        : 0
    "
    :saddle-handlebar-drop="bikeFinalSetup.setupResult?.HandlebarDrop"
    :saddle-handlebar-drop-diff="
      bikeData?.SF_SADDLE_HANDLEBAR_DROP
        ? bikeData?.SF_SADDLE_HANDLEBAR_DROP -
          bikeFinalSetup.setupResult?.HandlebarDrop
        : 0
    "
    :saddle-height="bikeFinalSetup.setupResult?.SaddleHeight"
    :saddle-height-diff="
      bikeData?.SF_SADDLE_HEIGHT
        ? bikeData?.SF_SADDLE_HEIGHT - bikeFinalSetup.setupResult?.SaddleHeight
        : 0
    "
    :saddle-to-handlebar="bikeFinalSetup.SADDLE_HANDLEBAR_DISTANCE"
    :saddle-to-handlebar-diff="
      bikeData?.SF_SADDLE_HANDLEBAR_DISTANCE
        ? bikeData?.SF_SADDLE_HANDLEBAR_DISTANCE -
          bikeFinalSetup.SADDLE_HANDLEBAR_DISTANCE
        : 0
    "
    :saddle-width="80"
    :reach="bikeFinalSetup.setupResult?.FrameReach"
    :stack="bikeFinalSetup.setupResult?.FrameStack"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBikeStore } from '@/store/bikeStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { getBikeCategory } from '@/utils/utils'
import BikeSetup from '@/components/preview/common/BikeSetup.vue'

const bikeStore = useBikeStore()
const measurementStore = useMeasurementStore()

const { bikeData, bikeFinalSetup } = storeToRefs(bikeStore)
const { finalMeasurement } = storeToRefs(measurementStore)
</script>

<style lang="scss"></style>
